<template>
  <div class="component-content">
    <div class="oa-nav">
      <router-link to="/Project/List" v-if="backNavRole('PM')">
        <div class="nav-item">
          <span class="iconfont icon-xiangmuguanli"></span>
          <span class="title">工程项目</span>
        </div>
      </router-link>
      <router-link to="/Contract/List" v-if="backNavRole('CT')">
        <div class="nav-item">
          <span class="iconfont icon-icon-test"></span>
          <span class="title">合同</span>
        </div>
      </router-link>
      <router-link to="/Pay/List" v-if="backNavRole('PAY')">
        <div class="nav-item">
          <span class="iconfont icon-pay-circle"></span>
          <span class="title">款项/支付</span>
        </div>
      </router-link>
      <router-link to="/Meeting/List" v-if="backNavRole('CM')">
        <div class="nav-item">
          <span class="iconfont icon-huiyishi"></span>
          <span class="title">会议</span>
        </div>
      </router-link>
      <router-link to="/Seal/List" v-if="backNavRole('SM')">
        <div class="nav-item">
          <span class="iconfont icon-icon-test"></span>
          <span class="title">印章</span>
        </div>
      </router-link>
      <router-link to="/Storage/Detail" v-if="backNavRole('ST')">
        <div class="nav-item">
          <span class="iconfont icon-cangku"></span>
          <span class="title">材料/仓库</span>
        </div>
      </router-link>

      <router-link to="/User/Approval/List">
        <div class="nav-item">
          <span class="iconfont icon-shenpi"></span>
          <span class="title">待您审批</span>
          <span v-if="tipNum.spNum>0" class="nav-item-num">{{ tipNum.spNum }}</span>
        </div>
      </router-link>

    </div>
    <el-row :gutter="15">
      <div class="weather-content">
        <div class="cont-item overflow ">
          <div class="title red">
            <i class="iconfont icon-rili"></i> 今日天气
          </div>
          <div class="ci-content">
            <!-- <div class="rili">
              <iframe src="../../../static/rili.html" allowtransparency="true" width="475" height="394" frameborder="0"
                scrolling="no"></iframe>
            </div> -->
            <div class="weather">
              <iframe width="565" scrolling="no" height="70" frameborder="0" allowtransparency="true"
                src="http://i.tianqi.com/index.php?c=code&id=2&icon=1&py=xiangshan&num=3&site=12"></iframe>
            </div>
          </div>
        </div>
        <div class="cont-item overflow mt15" v-if="relateList">
          <div class="title green">
            <router-link class="name" to="/User/Seal/List"><i class="iconfont icon-icon-test"></i> 我的印章</router-link>
            <router-link class="more" to="/User/Seal/List">查看更多 ></span></router-link>
          </div>
          <div class="ci-content">
            <el-table :data="relateList.seals" style="width: 100%" v-loading="loading">
              <el-table-column prop="flowVO.name" label="申请主体">
              </el-table-column>
              <el-table-column prop="applyTime" label="申请时间">
              </el-table-column>
              <el-table-column prop="flowVO.status" label="状态" width="60px" align="right">
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- <div class="cont-item overflow mt15">
          <i class="iconfont icon-link"></i> 常用链接
          <ul class="link-list">
            <li>
              <a href="http://www.xswater.cn/" target="_blank">象山水务集团门户网站</a>
            </li>
            <li>
              <a href="http://www.xswater.cn/" target="_blank">象山水务集团门户网站 - 后台管理系统</a>
            </li>
          </ul>
        </div> -->

      </div>
      <div class="weather-content-r">
        <el-col :span="23">
          <!-- <p v-if="getReleteListIsNull()" style="padding:30px 26px;color:#555;">OA系统暂还没有更多与你有关的相关记录~</p> -->
          <div class="cont-item overflow" v-if="relateList && relateList.notices.length>0">
            <div class="title purple">
              <i class="iconfont icon-huiyishi"></i>
              <router-link class="name" to="/User/Notice/List">我的通知公告</router-link>
              <router-link class="more" to="/User/Notice/List">查看更多 ></router-link>
            </div>
            <div class="ci-content">
              <el-table :data="relateList.notices" style="width: 100%" v-loading="loading">
                <el-table-column label="通知标题">
                  <template slot-scope="scope">
                    <a href="javascript:;" class="link" @click="NoticeDetail(scope.row)">{{ scope.row.title }}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" align="right" width="130px" label="通知时间">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 通知公告详情 -->
          <notice-detail :noticeStatus="noticeStatus" v-on:hideNoticeDetail="hideNoticeDetail"
            :noticeDetail="noticeDetail" :isManager="isManager"></notice-detail>

          <div class="cont-item overflow" v-if="relateList && relateList.conferences.length>0">
            <div class="title green">
              <i class="iconfont icon-huiyishi"></i>
              <router-link class="name" to="/User/Meeting/List">我的会议</router-link>
              <router-link class="more" to="/User/Meeting/List">查看更多/操作 ></router-link>
            </div>
            <div class="ci-content">
              <el-table :data="relateList.conferences" style="width: 100%" v-loading="loading">
                <el-table-column label="会议名称">
                  <template slot-scope="scope">
                    <a href="javascript:;" class="link" @click="showMeetingInfo(scope.row.id)">{{ scope.row.name }}</a>
                    <el-tooltip v-if="scope.row.isHasAttas" class="item" effect="dark" content="点击查看会议资料"
                      placement="bottom">
                      <i @click="showMeetingInfo(scope.row.id)" class="el-icon-document meeting-name-icon"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column label="会议地点" width="100px">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.depName+' - '+scope.row.address"
                      placement="bottom">
                      <span>
                        <i class="iconfont icon-address"></i>
                        <span v-html="scope.row.address"></span>
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="conferenceTime" width="120px" label="会议时间">
                </el-table-column>
                <el-table-column prop="status" label="会议状态" width="70px" align="right">
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="cont-item overflow" v-if="relateList">
            <div class="title blue">
              <i class="iconfont icon-xiangmuguanli"></i>
              <router-link class="name" to="/User/Project/List">我的工程/项目</router-link>
              <router-link class="more" to="/User/Project/List">查看更多 ></router-link>
            </div>
            <div class="ci-content">
              <el-table :data="relateList.projects" style="width: 100%" v-loading="loading">
                <el-table-column prop="number" label="项目编号" width="100px">
                </el-table-column>
                <el-table-column label="项目名称">
                  <template slot-scope="scope">
                    <span v-if="scope.row.ctype" class="title-z">{{scope.row.ctype}}</span>
                    <router-link class="table-link" target="_blank" :to="'/Project/Detail/' + scope.row.id">
                      {{scope.row.name}}
                    </router-link>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="项目负责人" width="150px">
                  <template slot-scope="scope">
                    <user-info :userData='scope.row.leader'></user-info>
                  </template>
                </el-table-column> -->
                <el-table-column prop="status" width="70px" label="项目状态" align="right">
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="cont-item overflow" v-if="relateList">
            <div class="title purple">
              <i class="iconfont icon-hetong"></i>
              <router-link class="name" to="/User/Contract/List">我的合同</router-link>
              <router-link class="more" to="/User/Contract/List">查看更多 ></router-link>
            </div>
            <div class="ci-content">
              <el-table :data="relateList.contracts" style="width: 100%" v-loading="loading">
                <el-table-column label="合同名称">
                  <template slot-scope="scope">
                    <span v-html="getTypeName(scope.row.type)"></span>
                    <router-link :to="'/Contract/Detail/'+scope.row.id" class="link" target="_blank">{{ scope.row.name
                      }}</router-link>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="创建人" width="150px">
                  <template slot-scope="scope">
                    <user-info :userData='scope.row.creator'></user-info>
                  </template>
                </el-table-column> -->
                <el-table-column prop="status" label="状态" width="70px" align="right">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- <div class="cont-item overflow" v-if="relateList && relateList.flows.length>0">
            <div class="title green">
              <i class="iconfont icon-shenpi"></i>
              <router-link class="name" to="/User/Approval/List">我的审批</router-link>
              <router-link class="more" to="/User/Approval/List">查看详情 ></router-link>
            </div>
            <div class="ci-content">
              <el-table :data="relateList.flows" style="width: 100%" v-loading="loading">
                <el-table-column label="审批主体">
                  <template slot-scope="scope">
                    <span v-html="getApprovalTypeName(scope.row.approvalType)"></span>{{scope.row.name}}
                  </template>
                </el-table-column>
                <el-table-column label="审批发起人" width="150px">
                  <template slot-scope="scope">
                    <user-info :userData='scope.row.creator'></user-info>
                  </template>
                </el-table-column>
                <el-table-column label="审批提交时间" width="135px" align="right">
                  <template slot-scope="scope">
                    <span v-html="getDateByTime(scope.row.createTime)"></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
           -->
        </el-col>


        <!-- 会议资料详情 -->
        <meeting-info v-if="meetingId" :meetingId="meetingId" :meetingInfoStatus="meetingInfoStatus"
          v-on:hideMeetingInfo="hideMeetingInfo()"></meeting-info>


      </div>
    </el-row>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import NoticeDetail from '@/page/notice/components/noticeDetail'

  import UserInfo from '@/components/UserInfo'
  import approvalType from '@/Mixins/approvalType'
  import MeetingInfo from '@/components/MeetingInfo'

  import meetingMixin from '@/Mixins/meetingMixin'
  import Role from '@/Mixins/role'
  export default {
    mixins: [meetingMixin, approvalType, Role],
    computed: {
      ...mapState({
        tipNum: state => state.main.tipNum,
      })
    },
    components: {
      UserInfo,
      MeetingInfo,
      NoticeDetail,
    },
    data() {
      return {
        riliSrc: "http://oss.pioneeringedu.cn/rili.html?d=" + Math.random(),
        loading: true,

        msgList: {},

        relateList: "",

        // 审批
        approvalTypeName: ['未知', '印章', '工程', '合同'],
        // 合同
        typeName: ['合同', '工程合同', '子项目'],
        contractTypeName: ['独立合同', '工程施工合同', '子项目合同'],


        // 会议资料详情
        meetingInfoStatus: false,
        meetingId: "",


        // 详情
        noticeStatus: false,
        noticeDetail: '',
        isManager: false,
      }
    },
    created() {
      this.getRelateList()
    },
    mounted() {},
    methods: {
      // 通知公告详情
      NoticeDetail(row) {
        this.noticeStatus = true
        ajax.get('/notice/info/' + row.id, "", (res) => {
          this.noticeDetail = res.vo
        })
      },
      hideNoticeDetail() {
        this.noticeStatus = false
        this.noticeDetail = ""
      },

      getReleteListIsNull() {
        if (this.relateList) {
          if (this.relateList.conferences.length < 1 && this.relateList.contracts.length < 1 && this.relateList.projects
            .length < 1 &&
            this.relateList.seals.length < 1) {
            return true
          }
        }
        return false
      },

      // 合同类型
      getTypeName(type) {
        return '<span class="approval-type at' + type + '">' + this.typeName[type] + '</span>'
      },
      // 时间格式化
      getDateByTime(time) {
        return window.util.getFormatDate(time, true)
      },
      // 获取审批主体
      getApprovalTypeName(type) {
        return '<span class="approval-type at' + type + '">' + this.approvalTypeName[type] + '</span>'
      },
      // 获取与我相关
      getRelateList() {
        ajax.get('/msg/relate/me', '', (res) => {
          this.relateList = res.vo
          this.loading = false
        })
      },
    },
    watch: {
      "relateList"() {
        this.getReleteListIsNull()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/main/index.vue